var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisitorInfoMobile = function SvgVisitorInfoMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#visitor-info-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.486 9.357c-5.775-3.335-13.135-1.401-16.437 4.319L18.13 55.103c-3.303 5.72-1.298 13.06 4.478 16.395l52.29 30.189c5.775 3.335 13.135 1.401 16.437-4.319l23.918-41.427c3.302-5.72 1.297-13.06-4.478-16.395l-52.29-30.19Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.023 14.533c-7.374-1.504-14.559 3.197-16.048 10.5L7.187 77.922c-1.49 7.302 3.28 14.441 10.654 15.945l66.757 13.617c7.374 1.504 14.56-3.197 16.049-10.5l10.788-52.889c1.49-7.303-3.281-14.442-10.654-15.946L34.023 14.533Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.054 27.466c-6.438 0-11.657 5.373-11.657 12v48c0 6.628 5.219 12 11.657 12h58.285c6.438 0 11.657-5.372 11.657-12v-48c0-6.627-5.219-12-11.657-12H31.054Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m42.343 53.826-1.048 4.192h-5.378a1.844 1.844 0 0 0 0 3.687h49.167a1.844 1.844 0 0 0 0-3.687h-5.378l-1.048-4.192c-1.341-5.366-2.012-8.049-4.013-9.61-2-1.563-4.766-1.563-10.297-1.563h-7.696c-5.53 0-8.296 0-10.297 1.562-2 1.562-2.671 4.245-4.012 9.61Zm4.636 30.619a8.608 8.608 0 0 0 8.32-6.4l2.728-1.365a5.531 5.531 0 0 1 4.947 0l2.728 1.364a8.604 8.604 0 1 0-.063-4.154l-1.016-.508a9.219 9.219 0 0 0-8.246 0l-1.015.508a8.604 8.604 0 1 0-8.382 10.555Z",
    fill: "url(#visitor-info-mobile_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visitor-info-mobile_svg__b",
    x1: 61.115,
    y1: 84.445,
    x2: 61.115,
    y2: 42.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC2CA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBC2CA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "visitor-info-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgVisitorInfoMobile;